<div class="">
  <button mat-flat-button class="new-sorting-btn start-sm-0" [matMenuTriggerFor]="dateList" #menuTrigger="matMenuTrigger"
    [ngClass]="{'active': isDateApply}"
    (click)="onClickHandler()">
    <div class="d-flex align-items-center">
      <div class=" " (click)="isDateApply && removeDateFilter()" *ngIf="pageName !==  'dashboard'">
        <img src="../../../../assets/images/plus-circle.svg" alt="">
      </div>

      <span class="ms-2">{{displayBtnName}} <span *ngIf="isDateApply">| </span></span>

      <h6 class="m-0 ms-1" *ngIf="isDateApply"> {{selectedView}}</h6>
    </div>
  </button>

  <div>
    <mat-menu #dateList="matMenu" class="new-mat-menu mt-1 dateFilter" xPosition="before">
      <div class="p-3" (click)="stopPropagation($event)" style="box-sizing: border-box; width: 100%;">
        <p class="mb-2" style="font-size: 13px; font-weight: 700; color: #1e293b; font-family: 'Gilroy', sans-serif;">Filter by {{displayBtnName}}</p>
        
        <app-select
          size="compact"
          [options]="dateOptions"
          [(ngModel)]="selectedOption"
          (selectionChange)="onOptionChange($event)"
          placeholder="Select"
          class="w-100 mb-3"
        ></app-select>

        <div class="mt-2 DatepickOpen" *ngIf="DatepickOpen">
          <div [formGroup]="range">
            <div class="w-100 d-flex align-items-center gap-2 mb-3">
              <div class="flex-grow-1" style="width: 50%;">
                <app-date-picker
                  size="compact"
                  placeholder="Start Date"
                  formControlName="start"
                  [maxDate]="range.get('end')?.value"
                  (dateChange)="onStartDateChange($event)"
                ></app-date-picker>
              </div>
              <div class="flex-grow-1" style="width: 50%;">
                <app-date-picker
                  size="compact"
                  placeholder="End Date"
                  formControlName="end"
                  [minDate]="range.get('start')?.value"
                  (dateChange)="onEndDateChange($event)"
                ></app-date-picker>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-3">
          <app-primary-button
            label="APPLY"
            size="medium"
            [fullWidth]="true"
            [disabled]="!csvEndDate || csvStartDate > csvEndDate"
            (btnClick)="applyDate(selectedOption)"
          ></app-primary-button>
        </div>
      </div>
    </mat-menu>
  </div>

</div>